import { memo } from 'react';

function UnProcessMarker({ backgroundColor, borderColor, size }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
      <path d="M15.1867 12V4L8.26001 0L1.33334 4V12L8.26001 16L15.1867 12Z" fill={backgroundColor} />
      <path
        d="M8.26001 0.766667L14.52 4.38V11.6133L8.26001 15.2267L2.00001 11.6133V4.38667L8.26001 0.766667ZM8.26001 0L1.33334 4V12L8.26001 16L15.1867 12V4L8.26001 0Z"
        fill={borderColor}
      />
      <path
        d="M7.33333 9.33333H11.3333V7.33333H7.33333V5L4 8.33333L7.33333 11.6667V9.33333Z"
        fill={borderColor}
      />
    </svg>
  );
}

export default memo(UnProcessMarker);
